import { Link } from 'react-router-dom';

export default function SpecialOfferSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-amber-50 via-orange-50 to-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-12 lg:p-16">
              <div className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-bold mb-6">
                LIMITED TIME OFFER
              </div>
              <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                Get Your Free Quote Today!
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Contact us now for a free, no-obligation quote on your event entertainment rentals. We offer competitive pricing with no hidden fees.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-green-600"></i>
                  </div>
                  <p className="text-sm text-gray-700"><strong>Free Delivery</strong> within our service area</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-green-600"></i>
                  </div>
                  <p className="text-sm text-gray-700"><strong>Professional Setup</strong> included with every rental</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-green-600"></i>
                  </div>
                  <p className="text-sm text-gray-700"><strong>Same-Day Service</strong> available for last-minute events</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-green-600"></i>
                  </div>
                  <p className="text-sm text-gray-700"><strong>Flexible Packages</strong> to fit any budget</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/contact" 
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors text-center whitespace-nowrap"
                >
                  Request Free Quote
                </Link>
                <a 
                  href="tel:6102532835" 
                  className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors text-center whitespace-nowrap"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  Call Now
                </a>
              </div>
            </div>

            <div className="relative h-64 lg:h-auto">
              <img 
                src="https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png"
                alt="Fun Affairs Special Offer"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/80 to-transparent lg:from-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}